import s17 from './succulents/Aloe/17.jpg';
import s18 from './succulents/Aloe/18.jpg';
import s19 from './succulents/Aloe/19.jpg';
import s20 from './succulents/Aloe/20.jpg';

let Aloe = [

    {
        key: 17,
        name: 'PINK BLUSH ALOE',
        img: s17,
        price: 5,
        description: 'A cute aloe species with pink ridges. The textured leaves are dark green mixed with soft green markings.',
    },

    {
        key: 18,
        name: 'ALOE PERFOLIATA',
        img: s18,
        price: 5,
        description: "It spreads out in clusters along the ground as it grows. Its spear-shaped leaves have harmless off-white to yellow “teeth” along the ridges.",
        descriptionLong: "This blue-green succulent spreads out in clusters along the ground as it grows. Its spear-shaped leaves have harmless off-white to yellow “teeth” along the ridges, and bumps along the underside of the leaves.",
    },

    {
        key: 19,
        name: 'POTHOS',
        img: s19,
        price: 5,
        description: "Also called Devil’s Ivy, it has shiny, heart-shaped leaves and comes in a number of natural and cultivated varieties.",
        descriptionLong: "Also called Devil’s Ivy, is a tropical vine plant that has adapted well as a hardy houseplant. It has shiny, heart-shaped leaves and comes in a number of natural and cultivated varieties to add interesting foliage to your home.",
    },

    {
        key: 20,
        name: 'ALOE VERA',
        img: s20,
        price: 12,
        description: 'Is distinguished by its thick, pointed, and juicy green leaves with a toothed border.',
        descriptionLong: 'Is distinguished by its thick, pointed, and juicy green leaves with a toothed border that can grow to be 12–19 inches long. Each leaf has a slimy layer that retains water, making the leaves thick.',
    },
]

export default Aloe;